import { render, staticRenderFns } from "./physiqueTest.vue?vue&type=template&id=42aa9e5f&scoped=true&"
import script from "./physiqueTest.vue?vue&type=script&lang=js&"
export * from "./physiqueTest.vue?vue&type=script&lang=js&"
import style0 from "./physiqueTest.vue?vue&type=style&index=0&id=42aa9e5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa9e5f",
  null
  
)

export default component.exports